import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';

export const getBestImageUrl = (item, fallback = null) => {
  if (!item) return fallback;
  const primary = item.images?.primary;
  if (primary?.thumbnailUrl) return primary.thumbnailUrl;
  if (primary?.mediumUrl) return primary.mediumUrl;
  if (item.image) return item.image; // legacy field support
  return fallback;
};

export const isFirebaseStorageUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  return url.includes('firebasestorage.app') || url.includes('localhost:9198');
};

export const extractStorageFilePath = (url) => {
  try {
    const parts = url.split('/o/');
    if (parts.length > 1) {
      return decodeURIComponent(parts[1].split('?')[0]);
    }
  } catch (_e) {
    // ignore
  }
  return null;
};

export const getAuthenticatedStorageUrl = async (url) => {
  try {
    if (!isFirebaseStorageUrl(url)) return url;
    const filePath = extractStorageFilePath(url);
    if (!filePath) return url;
    const fileRef = ref(storage, filePath);
    const downloadUrl = await getDownloadURL(fileRef);
    return downloadUrl;
  } catch (error) {
    console.error('🖼️ [Auth URL Error] Failed to get authenticated URL:', error);
    return url;
  }
};


